import { Trans } from "@web-monorepo/i18n/macro";
import { DDSButton } from "@web-monorepo/dds";
import { clsx } from "clsx";
import { Link } from "react-router-dom";
import { displayClose as displayCloseActionCreator } from "src/pods/realtime";
import { useToolkitRealtimeStore } from "src/pods/realtime/toolkitRealtimeStore";
import { dispatchToolkitReduxAction } from "src/state/toolkitReduxStore";
import styles from "./CastControl.module.css";

interface Props {
  onRequestStart?: VoidFunction;
  onRequestStop?: VoidFunction;
  className?: string;
}

export default function CastControl({ onRequestStart, onRequestStop, className }: Props) {
  const { paired: isConnected, displayOn: isCasting } = useToolkitRealtimeStore();
  const handleStop = onRequestStop ?? (() => dispatchToolkitReduxAction(displayCloseActionCreator()));

  if (!isConnected) {
    return (
      <section className={clsx(styles.bar, className)}>
        <span>
          <Trans>No computer connected!</Trans>
        </span>
        <Link to="/apps/help/what-is-dojocast" className={styles.helpLink}>
          <Trans>Learn more</Trans>
        </Link>
      </section>
    );
  }

  if (isCasting) {
    return (
      <section className={clsx(styles.bar, styles.barCasting, className)}>
        <span>
          <Trans>Casting to computer</Trans>
        </span>
        <DDSButton
          variant="unstyled"
          data-name="cast_control:render:cast_control_stop"
          className={clsx(styles.actionButton, styles.stopButton)}
          onClick={handleStop}
        >
          <Trans>Stop</Trans>
        </DDSButton>
      </section>
    );
  }

  return (
    <section className={clsx(styles.bar, className)}>
      <span>
        <Trans>Computer detected</Trans>
      </span>
      <DDSButton
        variant="unstyled"
        data-name="cast_control:render:cast_control_start"
        className={styles.actionButton}
        onClick={onRequestStart}
      >
        <Trans>Start DojoCast</Trans>
      </DDSButton>
    </section>
  );
}
